// extracted by mini-css-extract-plugin
export var form = "_fs-0";